import parse, { domToReact } from 'html-react-parser';

export const cleanHtmlContent = (htmlString) => {
  return parse(htmlString, {
    replace: (domNode) => {
      if (domNode.name === 'p') {
        // Strip styles from paragraphs but keep content
        return <p>{domToReact(domNode.children)}</p>;
      }

      if (domNode.attribs && domNode.attribs.style) {
        delete domNode.attribs.style;
      }

      // Remove any other tags that are not 'p'
      if (domNode.name !== 'p') {
        return null;
      }
    },
  });
};
